export default __webpack_public_path__ + "static/media/setaCimaVerde.49eded6e.svg";